var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "PngFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "PNG",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.1851513 12.800251q0 .250631-.082682.45217-.082682.201538-.2377117.343648-.1524456.14211-.3772382.219625-.2222088.07752-.5322676.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036173.02584-.023254.0078-.067179.01292-.041341.0078-.1059368.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036173-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214397-.04392h.715719q.1085206 0 .2067059.01033.1007691.0078.2351279.03876.1369426.02842.2764691.111105.1421102.0801.2402955.198954.098185.118856.1498618.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065-.074931-.136942-.188619-.204122-.1111044-.06718-.2325441-.08527-.1188559-.01809-.2325441-.01809H4.5754295v1.341005h.4004926q.2015382 0 .3333132-.05168.1343588-.05168.2247926-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM9.3968435 14.980998q0 .05168-.018087.08785-.015503.03617-.043925.05943-.025838.02326-.059428.03359-.03359.01033-.067179.01033H9.0661141q-.067179 0-.1188559-.01292-.049093-.0155-.095601-.05168-.043925-.03876-.090434-.103353-.043925-.0646-.098185-.165365L7.6088378 12.937194Q7.5261555 12.789916 7.4408893 12.629719 7.358207 12.466938 7.28586 12.314493h-.00517q.00517.186035.00775.379822.00258.193786.00258.384989v2.017966q0 .01809-.010335.03617-.010335.0155-.036174.02584-.023254.0078-.064596.01292-.038757.0078-.1007691.0078-.062012 0-.1033529-.0078-.038757-.0052-.062012-.01292-.023254-.01033-.03359-.02584-.010335-.01809-.010335-.03617v-3.085085q0-.103352.056844-.147277.056844-.04392.1240235-.04392h.2118735q.074931 0 .1240236.01292.051676.01292.090434.04392.041341.02842.077515.08268.038757.05168.082682.131775l.8113205 1.467612q.074931.134358.1446941.263549.069763.126608.1343588.250631.064596.124024.1266073.245464.064596.118855.1266073.240295h.00258q-.00517-.204122-.00775-.423747 0-.222209 0-.426331v-1.813844q0-.01809.010335-.03359.010335-.0155.03359-.02584.025838-.01292.064596-.01809.041341-.0052.1059367-.0052.056844 0 .098185.0052.041341.0052.064596.01809.023254.01034.03359.02584.010335.0155.010335.03359zM12.802322 12.275735q0 .04909-.0052.08785-.0052.03617-.0155.06201-.01033.02326-.02584.03359-.0155.01033-.03359.01033-.03101 0-.103353-.04909-.07235-.04909-.193787-.10852-.121439-.05943-.291972-.108521-.167948-.04909-.400492-.04909-.276469 0-.496094.100769-.219625.100769-.372071.279053-.152446.178284-.235128.423747-.0801.245463-.0801.532267 0 .320394.08785.568441.09043.248047.248047.41858.157613.170532.374654.258382.219625.08785.480591.08785.155029 0 .312643-.03617.160197-.03876.297139-.113689v-.974101h-.775147q-.04392 0-.06718-.04392-.02067-.04392-.02067-.136943 0-.04909.0052-.08268.0052-.03617.0155-.05684.01292-.02326.02842-.03359.0155-.01033.03876-.01033h1.061952q.02842 0 .05684.01033.02842.01033.05168.03101.02325.02067.03617.05684.01292.03617.01292.08268v1.273824q0 .06718-.02325.116272-.02326.04909-.09819.08785-.07493.03617-.193786.0801-.118856.04392-.245464.07493-.126607.03101-.255798.04651-.129191.0155-.255799.0155-.387573 0-.692464-.118856-.304891-.12144-.516765-.343649-.20929-.222209-.320394-.532267-.111104-.310059-.111104-.692465 0-.397909.118855-.720887.12144-.322978.338481-.550354.219625-.227376.524516-.3514.307475-.126607.679546-.126607.191203 0 .359151.03359.167949.03359.29714.0801.131775.04392.219625.09819.09043.05168.124023.08527.03359.03359.04651.07752.01292.04393.01292.126607z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.573d72786d61d0916268da31896e09d1.svg";
export { ForwardRef as ReactComponent };